module.exports = __webpack_public_path__ + "img/me2.4fdb0b34.png";